/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1PoliticalTransparency } from '../models/V1PoliticalTransparency';
import { HttpFile } from '../http/http';

/**
* Campaign information relevant to the order line
*/
export class V1OrderLineCampaign {
    'id'?: string;
    'name'?: string;
    'politicalTransparency'?: V1PoliticalTransparency;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "politicalTransparency",
            "baseName": "political_transparency",
            "type": "V1PoliticalTransparency",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineCampaign.attributeTypeMap;
    }

    public constructor() {
    }
}

